import React from 'react';

const Loader = () => {
  return (
    <div className="my-[100px]">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
